/* V2 - Chat Window */

import * as _ from "lodash";
import * as React from "react";
import * as moment from "moment";
import { connect } from "react-redux";
import AppLoader from "../../components/utils/AppLoader";
import { AppConstants, AppMessages } from "../../utils/AppConstants";
import { TwilioActions } from "../../actions/TwilioActions";
import { IAppState } from "../../models/IAppState";
import { ITwilioContext } from "../../models/ITwilioContext";
import { default as AppUtils, LOADING_STATE } from "../../utils/AppUtils";
import IDoctorProfile from "../../models/IDoctorProfile";
import { ORION_IMG_URL } from "../../utils/AppConstants";
import RollbarUtils from "../../utils/RollbarUtils";
import FileUploader from "../../components/common/FileUploader";
import CTA, { CTATheme } from "../../components/common/CallToAction";
import { Form } from "../../components/common/Form/Form";
import TextInput from "../../components/TextInput";
import AlbusApis from "../../api/AlbusApis";
import ApiUtils from "../../utils/ApiUtils";
import { ApiManager } from "../../api/ApiManager";
import { Tracker } from "../../utils/Tracker";
import { EventNames } from "../../utils/EventTrackerConstants";
import RenderConfidentialData from "../../components/common/RenderConfidentialData";

declare var Twilio: any;
const NUMBER_OF_MESSAGES_TO_FETCH_IN_SINGLE_CALL: number = 50;
const DEFAULT_PDF_ATTACHMENT_THUMBNAIL_IMAGE =
  ORION_IMG_URL + "icons/pdf-attachment.svg"; // TODO (16th June 2017): Finalize the image and download. (Ask UI team to provide with default icons)
const DEFAULT_IMAGE_ATTACHEMENT_THUMBNAIL_IMAGE =
  ORION_IMG_URL + "icons/jpg-attachment.svg";
const DEFAULT_ASSET_ATTACHMENT_THUMBNAIL_IMAGE =
  ORION_IMG_URL + "attachment-icon.svg";

export enum MESSAGE_SOURCE_TYPE {
  MINE,
  OTHERS,
}

const MESSAGE_TYPE = {
  SIMPLE_TEXT: "SIMPLE_TEXT",
  RICH_TEXT: "RICH_TEXT",
  ASSET: "ASSET",
};

const MESSAGE_SUB_TYPE = {
  PDF: "PDF",
  IMAGE: "IMAGE",
};

interface IMessageAttribute {
  messageType: string;
  messageSubType?: string;
  attachmentCaption?: string;
  thumbnailImage?: string;
  assetKey?: string;
  attachmentSize?: string;
}

const DEFAULT_MESSAGE_ATTRIBUTE: IMessageAttribute = {
  // Currently Docs App supports sending only simple text. Hence using this default Message Attributes.
  messageType: MESSAGE_TYPE.SIMPLE_TEXT,
};

export enum LOADING_INITIAL_MESSAGES_STATE {
  NOT_INITIALIZED,
  LOADING,
  LOADED,
}

export interface IChatMessage {
  index?: number;
  messageSourceType: MESSAGE_SOURCE_TYPE;
  messageType: string;
  messageSubType?: string;
  thumbnailImage?: string; // Should be used when messageBody carries an Attachment URL.
  attachmentCaption?: string;
  from: string;
  messageBody: string;
  timestamp: string;
  assetUrl?: string;
  assetTags?: string;
}

interface IChatContainerProps {
  isExpanded?: boolean;
  doctorProfile: IDoctorProfile;
  twilioContext: ITwilioContext;
  communicationAccessToken: string;
  userIdentity: string;
  chatChannelName: string;
  chatChannelSid?: string; // This prop is optional, if not given, logic will work with chatChannelName. (But for performance always provide chatChannelSid.)
  updateCurrentChannel: (channelSid: string) => void;
  setCurrentChannel: (channel: any) => void;
  updateConsumptionHorizon: (channelSid: string, prevMessage: any) => void;
  getUnreadMessagesInfo: (doctorId: string) => void;
  currentChannel: any;
  clientsLoading: boolean;
  patientName?: string;
  toogleUnreadDotOnMobileChatHead(): void;
  toggleFileUploadScreen: () => void;
  showFileUploadScreen: boolean;
  removeUnReadMessage: (channelSid: string,unreadMessageInfo: any) => void; //) => void;
}

interface IChatContainerState {
  remotePersonName: string;
  totalMessagesToLoad: number;
  loadingMessageState: LOADING_INITIAL_MESSAGES_STATE;
  initializationState?: LOADING_STATE;
  chatMessages: IChatMessage[];
  fetchingChannelMyself: boolean;
  scrolledToBottom: boolean;
  fetchingPrevMessages: boolean;
  remainingMessagesToLoad: number;
  currFetchedPage: any;
  attachmentDetails: {
    assetKey: string;
    type: string;
    title: string;
    attachmentSize: string;
  };
}

let client: any;
let activeChannel: any;

const MOCK_CHAT: boolean = false; // Always make false in PROD. Use only for DEV UI Testing.
const DUMMY_CHAT: IChatMessage[] = [
  {
    messageSourceType: MESSAGE_SOURCE_TYPE.MINE,
    messageType: MESSAGE_TYPE.SIMPLE_TEXT,
    from: "doctor",
    messageBody: "Hi",
    timestamp: "",
  },
  {
    messageSourceType: MESSAGE_SOURCE_TYPE.OTHERS,
    messageType: MESSAGE_TYPE.SIMPLE_TEXT,
    from: "sumit",
    messageBody: "Hey",
    timestamp: "",
  },
  {
    messageSourceType: MESSAGE_SOURCE_TYPE.MINE,
    messageType: MESSAGE_TYPE.SIMPLE_TEXT,
    from: "doctor",
    messageBody: "How are you?",
    timestamp: "",
  },
  {
    messageSourceType: MESSAGE_SOURCE_TYPE.MINE,
    messageType: MESSAGE_TYPE.SIMPLE_TEXT,
    from: "doctor",
    messageBody: "Feeling well?",
    timestamp: "",
  },
  {
    messageSourceType: MESSAGE_SOURCE_TYPE.OTHERS,
    messageType: MESSAGE_TYPE.ASSET,
    messageSubType: MESSAGE_SUB_TYPE.PDF,
    thumbnailImage:
      "https://upload.wikimedia.org/wikipedia/commons/e/ec/Pdf_by_mimooh.svg",
    attachmentCaption: "Blood Test Report.",
    from: "sumit",
    messageBody: "http://www.pdf995.com/samples/pdf.pdf",
    timestamp: "",
  },
];

class ChatContainer extends React.Component<
  IChatContainerProps,
  IChatContainerState
> {
  constructor(props: IChatContainerProps) {
    super(props);
    this.state = {
      remotePersonName: "Bob",
      totalMessagesToLoad: 0,
      loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADING,
      chatMessages: [],
      fetchingChannelMyself: false,
      scrolledToBottom: false,
      fetchingPrevMessages: false,
      remainingMessagesToLoad: 0,
      currFetchedPage: null,
      attachmentDetails: null,
    };
  }

  private chatContainerEl: any;
  private _logError: any;
  private messageAlert: HTMLAudioElement = new Audio(
    "/sound/message-alarm.mp3"
  );
  private startLoadTIme: number;
  private endLoadTIme: number;

  componentWillUnmount() {
    console.log("Chat unmounting");
    this.props.updateCurrentChannel(null);
    this.props.setCurrentChannel(null);
    this.removeListeners(activeChannel);
    activeChannel = null;
    client = null;
  }

  activateChat = () => {
    (
      document.getElementsByClassName("chat") as HTMLCollectionOf<HTMLElement>
    )[0].classList.add("active-chat");
  };

  scrollDownToLastMessage = () => {
    const chatMsgScrollCont = document.getElementById(
      "chatMessagesScrollContainer"
    );
    chatMsgScrollCont.scrollTop = chatMsgScrollCont.scrollHeight;
  };

  onEnterPressedInMessageInput = (event: any) => {
    const isMobile = AppUtils.getIsMobile();
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.props.updateConsumptionHorizon(this.props.chatChannelSid,this.props.twilioContext.unreadMessageInfo)
      if (event.target.value.trim() !== "") {
        this.sendMessage(event.target.value);
        event.target.value = "";
      }
      this.setChatTextBoxHeight(isMobile ? 55 : 30);
      this.scrollDownToLastMessage();
    } else {
      // Reset the height to auto to get proper scroll height
      const textBoxContEl = (
        document.getElementsByClassName(
          "write"
        ) as HTMLCollectionOf<HTMLElement>
      )[0];
      const oldHeight = textBoxContEl.offsetHeight;
      textBoxContEl.style.height = "auto";
      // Get scroll height
      const textBoxEl = document.getElementById("messageInputTextBox");
      const height = Math.max(textBoxEl.scrollHeight, isMobile ? 55 : 30);
      this.setChatTextBoxHeight(height);
      const newHeight = textBoxContEl.offsetHeight;
      if (newHeight !== oldHeight) {
        this.scrollDownToLastMessage();
      }
      activeChannel.typing();
    }
  };

  setChatTextBoxHeight = (height: number) => {
    const textBoxEl = document.getElementById("messageInputTextBox");
    const isMobile = AppUtils.getIsMobile();
    const textBoxContEl = (
      document.getElementsByClassName("write") as HTMLCollectionOf<HTMLElement>
    )[0];
    textBoxContEl.style.height = `${height + (isMobile ? 20 : 10)}px`; // Additional px for padding
  };

  onSendMessageButtonClicked = () => {
    const msgInputBoxEl = document.getElementById(
      "messageInputTextBox"
    ) as HTMLTextAreaElement;
    let value: string = String.raw`${msgInputBoxEl.value}`;
    if (value.trim() !== "") {
      this.sendMessage(value);
      msgInputBoxEl.value = ""; // Reset textBox value
    }
    const isMobile = AppUtils.getIsMobile();
    this.setChatTextBoxHeight(isMobile ? 55 : 30);
    this.scrollDownToLastMessage();
  };

  sendMessage = (value: string) => {
    value = value.split(String.fromCharCode(10)).join("\n");
    this.sendMessageOnActiveChannel(value, DEFAULT_MESSAGE_ATTRIBUTE);
  };

  sendMessageOnActiveChannel = (
    messageBody: string,
    messageAttributes: IMessageAttribute
  ) => {
    let myInstance = this;
    if (activeChannel && myInstance) {
      activeChannel
        .sendMessage(messageBody, messageAttributes)
        .then(function () {
          console.log("Message Sent Successfully.");
        });
    }
  };

  appendMessageInChatWindow = (newMessage: IChatMessage) => {
    let myInstance = this;
    let chatMessages = this.state.chatMessages;
    chatMessages.push(newMessage);
    this.setState({ chatMessages: chatMessages, scrolledToBottom: false });
  };

  updateChannels = (channel?: any) => {
    if (!_.isEmpty(this.props.chatChannelSid)) {
      if (!_.isEmpty(channel)) {
        this.setState({ initializationState: LOADING_STATE.LOADING });
        this.setActiveChannel(channel);
      }
    }
  };

  onChannelsPageReceived = (page: any, self: any) => {
    let foundCurrentChatChannel: boolean = self.onSortedChannelListReceived(
      page.items,
      self
    );
    if (!foundCurrentChatChannel) {
      if (page.hasNextPage) {
        page.nextPage().then((nextPage: any) => {
          self.onChannelsPageReceived(nextPage, self);
        });
      }
    }
  };

  onSortedChannelListReceived = (channels: any, self: any) => {
    for (let i = 0; i < channels.length; i++) {
      if (channels[i].uniqueName === self.props.chatChannelName) {
        self.setActiveChannel(channels[i]);
        return true;
      }
    }
    return false;
  };

  getUserIdentity = () => {
    let userIdentity = this.props.userIdentity;
    let currentChannel = !_.isEmpty(
      this.props.twilioContext.currentChannel.channel
    )
      ? this.props.twilioContext.currentChannel.channel
      : activeChannel;
    if (currentChannel) {
      currentChannel.members.forEach((member: any) => {
        if (member.state.identity.includes("Doctor")) {
          userIdentity = member.state.identity;
        }
      });
    }
    return userIdentity;
  };

  // updateConsumptionHorizon = (messageIndex: number) => {
  //     this.props.updateConsumptionHorizon(this.props.chatChannelSid, this.getUserIdentity(), messageIndex, new Date().getTime()).then(() => {
  //         this.props.getUnreadMessagesInfo(this.props.doctorProfile.id);
  //     });
  // }

  createMessage = (message: any, shouldAppendToChatWindow: boolean) => {
    let messageAttributes: IMessageAttribute = message.attributes;
    let messageType: string = MESSAGE_TYPE.SIMPLE_TEXT;
    let thumbnailImage: string = undefined;
    let attachmentCaption: string = undefined;

    if (messageAttributes) {
      messageType = messageAttributes.messageType;
      if (messageType === MESSAGE_TYPE.ASSET) {
        thumbnailImage = this.getThumbnailImageUrlForChatMessage(
          message.attributes
        );
        attachmentCaption = messageAttributes.attachmentCaption;
      }
    }

    let newMessage: IChatMessage = {
      index: message.index,
      messageSourceType: message.author.includes("Doctor")
        ? MESSAGE_SOURCE_TYPE.MINE
        : MESSAGE_SOURCE_TYPE.OTHERS,
      messageType: messageAttributes.messageType,
      from: message.author,
      messageBody: message.body,
      thumbnailImage: thumbnailImage,
      attachmentCaption: attachmentCaption,
      timestamp: message.state.timestamp,
      assetUrl: message.attributes.assetKey,
      assetTags: message.attributes.attachmentTag,
    };
    if (shouldAppendToChatWindow) this.appendMessageInChatWindow(newMessage);
    return newMessage;
  };

  addMessagePreviousMethod = (message: any, shouldUpdateHorizon?: boolean) => {
    this.createMessage(message, true);
    // message.channel.updateLastConsumedMessageIndex(message.index);                      // TODO : When we update the message consumption count here, we should update the "unread count badge" also
    if (this.props.isExpanded && shouldUpdateHorizon) {
      // this.updateConsumptionHorizon(message.index);
      activeChannel.advanceLastConsumedMessageIndex(message.index);
    }

    // if (this.state.loadingMessageState === LOADING_INITIAL_MESSAGES_STATE.LOADING) {
    //     this.setState({
    //         totalMessagesToLoad: this.state.totalMessagesToLoad - 1
    //     }, () => {
    //         if (this.state.totalMessagesToLoad === 0 || (AppUtils.isDefined(messageIndex) && messageIndexthis.state.totalMessagesToLoad)) {
    //             this.setState({
    //                 loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADED,
    //                 initializationState: LOADING_STATE.LOADED
    //             });
    //         }
    //     });
    // }
  };

  addMessage = (
    message: any,
    options: { shouldUpdateHorizon?: boolean; appendToChat?: boolean }
  ) => {
    if (this.props.isExpanded && options.shouldUpdateHorizon) {
      activeChannel && activeChannel.advanceLastReadMessageIndex(message.index);
      // this.updateConsumptionHorizon(message.index);
    }
    return this.createMessage(message, options.appendToChat);
  };

  updateMessage = (message: any) => {
    this.createMessage(message, true);
  };

  fetchMessages = (
    channel: any,
    page: any,
    self: any,
    options: { updateHorizon: boolean }
  ) => {
    const pageItemsCount = page.items.length;
    const itemsToMap = options.updateHorizon
      ? _.reverse(page.items)
      : page.items;
    const fetchedMessages = itemsToMap.map((message: any, index: number) => {
      let shouldUpdateHorizon = index === 0 && options.updateHorizon;
      return self.addMessage(message, {
        shouldUpdateHorizon,
        appendToChat: false,
      });
    });
    this.setState(
      {
        remainingMessagesToLoad:
          this.state.remainingMessagesToLoad - pageItemsCount,
      },
      () => {
        // TODO: remove the logic this.state.remainingMessagesToLoad <= 0 & put === instead again
        if (
          (this.state.loadingMessageState ===
            LOADING_INITIAL_MESSAGES_STATE.LOADING &&
            this.state.remainingMessagesToLoad <= 0) ||
          (this.state.remainingMessagesToLoad > 0 &&
            this.state.remainingMessagesToLoad < this.state.totalMessagesToLoad)
        ) {
          this.setState({
            loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADED,
            initializationState: LOADING_STATE.LOADED,
          });
        }
      }
    );
    let messages = this.state.chatMessages;
    self.setState(
      {
        chatMessages: options.updateHorizon
          ? _.reverse(fetchedMessages)
          : [...fetchedMessages, ...messages],
        currFetchedPage: page,
        fetchingPrevMessages: false,
      },
      () => {
        if (!AppUtils.isDefined(this.endLoadTIme)) {
          this.endLoadTIme = performance.now();
          const timeStamp = new Date(
            new Date().getTime() - this.endLoadTIme + this.startLoadTIme
          ).toUTCString();
          const flowContext = AppUtils.getFlowContextFromUrl();
          const loadTime = (
            (this.endLoadTIme - this.startLoadTIme) /
            1000
          ).toFixed(2);
          Tracker.track(EventNames.Chat_Container_Load, {
            flow: flowContext,
            loadStartTimeStamp: timeStamp,
            doctorId: this.props.doctorProfile.id,
            patientId: this.props.twilioContext.patient.id,
            specialityCode: this.props.doctorProfile.primarySubServiceType.code,
            chatLoadTime: loadTime,
          });
          console.log("Chat took", this.endLoadTIme - this.startLoadTIme, "ms");
        }
      }
    );
  };

  fetchPrevMessages = (channel: any, page: any) => {
    if (page.hasPrevPage) {
      page.prevPage().then((prevPage: any) => {
        const oldScrollHeight = this.chatContainerEl.scrollHeight;
        this.fetchMessages(channel, prevPage, this, { updateHorizon: false });
        const currScrollHeight = this.chatContainerEl.scrollHeight;
        this.chatContainerEl.scrollTop = currScrollHeight - oldScrollHeight;
      });
    }
  };

  removeListeners = (activeChannel: any) => {
    if (activeChannel) {
      activeChannel.removeListener('messageAdded', this.handleNewMessage);
      activeChannel.removeListener('messageUpdated', this.updateMessage);
      
    }
  };

  alertUser = () => {
    this.messageAlert.play();
    if (navigator.vibrate) {
      navigator.vibrate(5);
    }
    if (!this.props.isExpanded && this.props.toogleUnreadDotOnMobileChatHead) {
      this.props.toogleUnreadDotOnMobileChatHead();
    }
  };
  handleNewMessage = (message: any) => {
    this.addMessage(message, { appendToChat: true });
    if (message.author.toLowerCase().indexOf("doctor") === -1) {
      // check if the message is from patient and not doctor
      this.alertUser();
    }
  };
  setActiveChannel = (channel: any) => {
    console.time("setActiveChannel");
    activeChannel = channel;
    channel.on("messageAdded",this.handleNewMessage);
    channel.on("messageUpdated", this.updateMessage);
    // activeChannel.on("typingStarted", () => {
    //   // process the member to show typing
    //   console.log("typing started");
    // });

    // activeChannel.on("typingEnded", () => {
    //   // process the member to show typing
    //   console.log("typing ended");
    // });

    channel.getMessagesCount().then((messagesCount: number) => {
      if (messagesCount > 0) {
        this.setState({
          totalMessagesToLoad: messagesCount,
          remainingMessagesToLoad: messagesCount,
        });
        channel
          .getMessages(NUMBER_OF_MESSAGES_TO_FETCH_IN_SINGLE_CALL)
          .then((page: any) => {
            console.timeEnd("setActiveChannel");
            this.fetchMessages(channel, page, this, { updateHorizon: true });
          });
      } else {
        this.setState({
          loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADED,
          initializationState: LOADING_STATE.LOADED,
        });
      }
    });
  };

  onAssetClick = (key: string, isDoctorMsg: boolean) => {
    let splitString = key.split("/");
    let uuid = splitString[splitString.length - 1];
    let authorId = splitString[splitString.length - 2].replace(
      isDoctorMsg ? "Doctor-" : "Patient-",
      ""
    );
    let newWindow: Window = window.open("", "_blank");
    const referenceType = isDoctorMsg ? "DOCTOR" : "PATIENT";
    ApiManager.getAlbusApis()
      .getDocPreSignedUrlForDownload(referenceType, authorId, uuid)
      .then((response: any) => {
        newWindow.location.replace(response.url);
      })
      .catch((e) => {
        console.log(e);
        console.log("something went wrong");
      });
  };

  getSingleChatMessageUIDiv = (
    index: number,
    chatMessage: IChatMessage,
    shouldShouldChatOwnerName: boolean
  ) => {
    const isDoctorMsg: boolean =
      chatMessage.messageSourceType === MESSAGE_SOURCE_TYPE.MINE;
    let cName = "bubble " + (isDoctorMsg ? "me" : "you");
    let chatMessageUI;
    if (chatMessage.messageType === MESSAGE_TYPE.SIMPLE_TEXT) {
      chatMessageUI = (
        <div key={index} className={cName}>
          {/* {shouldShouldChatOwnerName &&
                        <div className="chat-owner">{chatMessage.from.indexOf("Doctor") === -1 ? this.props.patientName : "You"}</div>
                    } */}
          <RenderConfidentialData>
            {chatMessage.messageBody}
          </RenderConfidentialData>
          <div className={"timestamp-container"}>
            {AppUtils.getHourMinuteFormattedDate(chatMessage.timestamp)}
          </div>
        </div>
      );
    } else if (chatMessage.messageType === MESSAGE_TYPE.ASSET) {
      let thumbnailUrl: string =
        this.getThumbnailImageUrlForChatMessage(chatMessage);
      // let thumbnailUrl: string = (chatMessage.thumbnailImage && chatMessage.thumbnailImage.length > 0) ? chatMessage.thumbnailImage : DEFAULT_PDF_ATTACHMENT_THUMBNAIL_IMAGE;
      chatMessageUI = (
        <div key={index} className={cName}>
          {/* {shouldShouldChatOwnerName &&
                        <div className="chat-owner">{chatMessage.from.indexOf("Doctor") === -1 ? this.props.patientName : "You"}</div>
                    } */}
          {/*<a target="_blank" href={AssetProvider.getCDNAwareImgUrlForUploads(`/${chatMessage.assetUrl}`)}><img src={thumbnailUrl}/></a>*/}
          <a
            onClick={() => this.onAssetClick(chatMessage.assetUrl, isDoctorMsg)}
          >
            <img src={thumbnailUrl} />
          </a>
          {chatMessage.attachmentCaption &&
            chatMessage.attachmentCaption.length > 0 && (
              <div>
                <br />
                <span>{chatMessage.attachmentCaption}</span>
                <br />
                {!_.isEmpty(chatMessage.assetTags) && (
                  <span>
                    {this.generateAssetTagsFromString(chatMessage.assetTags)}
                  </span>
                )}
              </div>
            )}
          <div className={"timestamp-container"}>
            {AppUtils.getHourMinuteFormattedDate(chatMessage.timestamp)}
          </div>
        </div>
      );
    }

    return chatMessageUI;
  };

  generateChatMessages = () => {
    // let chatMessages: any = [];
    let currentDate: string = null;
    return _.map(
      this.state.chatMessages,
      (chatMessage: IChatMessage, index: number) => {
        let dateSeparator = null;
        if (
          _.isNull(currentDate) ||
          !moment(chatMessage.timestamp).isSame(currentDate, "day")
        ) {
          if (!_.isEmpty(chatMessage.messageType)) {
            currentDate = chatMessage.timestamp;
            dateSeparator = (
              <div className="date-separator">
                <span>
                  {moment(chatMessage.timestamp).format("Do MMM, YYYY")}
                </span>
              </div>
            );
          }
        }
        // chatMessages.push(this.getSingleChatMessageUIDiv(index, chatMessage));
        const shouldShouldChatOwnerName: boolean = index
          ? this.state.chatMessages[index].from !==
            this.state.chatMessages[index - 1].from
          : true;
        return [
          dateSeparator,
          this.getSingleChatMessageUIDiv(
            index,
            chatMessage,
            shouldShouldChatOwnerName
          ),
        ];
      }
    );
    // return chatMessages;
  };

  generateAssetTagsFromString = (tags: string) => {
    let tagsMarkup: any[] = [];
    let tagArray = tags.split("#");
    _.map(tagArray, (tag) => {
      if (tag !== "") {
        tagsMarkup.push(<span className={"asset-tag"}>{tag.trim()}</span>);
      }
    });
    return tagsMarkup;
  };

  getThumbnailImageUrlForChatMessage = (chatMessage: IChatMessage): string => {
    if (chatMessage.thumbnailImage && chatMessage.thumbnailImage.length > 0) {
      return chatMessage.thumbnailImage;
    } else {
      if (chatMessage.messageSubType === MESSAGE_SUB_TYPE.PDF) {
        return DEFAULT_PDF_ATTACHMENT_THUMBNAIL_IMAGE;
      } else if (chatMessage.messageSubType === MESSAGE_SUB_TYPE.IMAGE) {
        return DEFAULT_IMAGE_ATTACHEMENT_THUMBNAIL_IMAGE;
      } else {
        return DEFAULT_ASSET_ATTACHMENT_THUMBNAIL_IMAGE;
      }
    }
  };

  logChatLoadingError = (waitInSeconds?: number) => {
    this._logError = setTimeout(() => {
      console.table({ ERROR: "CHAT DID NOT LOAD" });
      RollbarUtils.sendErrorToRollbar(
        new Error("Chat did not load"),
        {
          channelSid: this.props.chatChannelSid,
          doctorId: this.props.doctorProfile.id,
        },
        (err: any, data: any) => {
          console.log("ERR", err);
          console.log("DATA", data);
        }
      );
    }, (waitInSeconds || 30) * 1000);
  };

  refreshComponent = () => {
    this.removeListeners(this.props.twilioContext.currentChannel.channel);
    this.setState({
      remotePersonName: "",
      totalMessagesToLoad: 0,
      loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADING,
      chatMessages: [],
      fetchingChannelMyself: false,
      remainingMessagesToLoad: 0,
      currFetchedPage: null,
    });
    clearTimeout(this._logError);
    this.logChatLoadingError();
  };

  componentDidUpdate(prevProps: IChatContainerProps) {
    // const chatContainer = document.querySelector("#chatMessagesScrollContainer");
    if (
      this.chatContainerEl &&
      this.chatContainerEl.children.length &&
      this.chatContainerEl.scrollHeight > 0 &&
      !this.state.scrolledToBottom
    ) {
      this.chatContainerEl.scrollTop =
        this.chatContainerEl.scrollHeight -
        this.chatContainerEl.clientHeight +
        120; // buffer scroll - 120
      this.setState({ scrolledToBottom: true });
      // const lastChild = chatContainer.children[chatContainer.children.length - 1];
      // if (lastChild) {
      //     lastChild.scrollIntoView();
      // }
    }

    if (
      prevProps.showFileUploadScreen !== this.props.showFileUploadScreen &&
      !this.props.showFileUploadScreen &&
      !_.isEmpty(this.state.attachmentDetails)
    ) {
      this.setState({
        attachmentDetails: null,
      });
    }
  }

  componentDidMount() {
    console.log("Chat container mounting");
    console.time("Chat container");
    this.startLoadTIme = performance.now();
    this.props.updateCurrentChannel(this.props.chatChannelSid);
    if (
      !_.isEmpty(this.props.communicationAccessToken) &&
      !_.isNull(this.props.twilioContext.currentChannel.channel)
    ) {
      this.initialization();
      console.timeEnd("Chat container");
    }
    this.chatContainerEl = document.getElementById(
      "chatMessagesScrollContainer"
    );
    if (this.chatContainerEl) {
      this.chatContainerEl.addEventListener(
        "scroll",
        this.handleChatContainerScroll
      );
    }
    if (_.isEmpty(this.props.currentChannel)) {
      this.logChatLoadingError();
    }
  }

  handleChatContainerScroll = (scrollEv: any) => {
    if (!this.state.fetchingPrevMessages) {
      const targetCont = scrollEv.target;
      if (
        this.state.remainingMessagesToLoad > 0 &&
        this.state.currFetchedPage &&
        targetCont.scrollHeight > targetCont.clientHeight &&
        targetCont.scrollTop === 0
      ) {
        this.setState({ fetchingPrevMessages: true });
        this.fetchPrevMessages(activeChannel, this.state.currFetchedPage);
      }
      console.log("SCROLL EV", targetCont.scrollTop);
    }
  };

  componentWillReceiveProps(nextProps: IChatContainerProps) {
    if (nextProps.chatChannelSid !== this.props.chatChannelSid) {
      this.refreshComponent();
      this.props.updateCurrentChannel(nextProps.chatChannelSid);
      this.setState({ initializationState: LOADING_STATE.NOT_INITIALIZED });
    } else {
      if (!this.props.twilioContext.channelsSynced) {
        if (!_.isNull(nextProps.twilioContext.currentChannel.channel)) {
          console.time("Chat container 2");
          this.initialization(nextProps.twilioContext.currentChannel.channel);
          if (this._logError) clearTimeout(this._logError);
          console.timeEnd("Chat container 2");
        }
      }

      // if (nextProps.isExpanded && !this.props.isExpanded) {
      //     if (this.state.chatMessages.length && nextProps.twilioContext.currentChannel && nextProps.twilioContext.currentChannel.channel) {
      //         nextProps.twilioContext.currentChannel.channel.advanceLastConsumedMessageIndex(this.state.chatMessages[this.state.chatMessages.length - 1].index)
      //         this.updateConsumptionHorizon(this.state.chatMessages[this.state.chatMessages.length - 1].index);
      //     }
      // }
    }
  }

  initialization = (channel?: any) => {
    if (MOCK_CHAT) {
      this.setState(
        {
          chatMessages: DUMMY_CHAT,
          loadingMessageState: LOADING_INITIAL_MESSAGES_STATE.LOADED,
        },
        () => {
          // TODO: loading messages
        }
      );
    } else {
      if (
        this.state.initializationState === undefined ||
        this.state.initializationState === LOADING_STATE.NOT_INITIALIZED
      ) {
        this.updateChannels(channel);
      }
    }
    this.activateChat();
    console.timeEnd("Chat container");
  };

  getMessageSubType = (fileType: string) => {
    if (fileType === "image/png" || fileType === "image/jpeg") {
      return "IMAGE";
    } else {
      return "PDF";
    }
  };

  getMessageAttribute = (params: any): IMessageAttribute => {
    return {
      attachmentCaption: params.title,
      messageType: MESSAGE_TYPE.ASSET,
      messageSubType: this.getMessageSubType(
        _.get(this.state.attachmentDetails, "type", "")
      ),
      assetKey: _.get(this.state.attachmentDetails, "assetKey", ""),
      attachmentSize: _.get(this.state.attachmentDetails, "attachmentSize", ""),
    };
  };

  handleUploadDoneClick = (val: any, resetFn: () => void) => {
    const msgAttributes = this.getMessageAttribute({
      title: val.title || this.state.attachmentDetails.title,
    });
    this.sendMessageOnActiveChannel("", msgAttributes);
    this.props.toggleFileUploadScreen();
    this.setState({
      attachmentDetails: null,
    });
    resetFn();
  };

  setAttachmentDetails = (
    fileName: string,
    mimeType: string,
    title: string,
    fileSize: number = 0
  ) => {
    this.setState({
      attachmentDetails: {
        assetKey: `CARE/Doctor-${this.props.doctorProfile.id}/${fileName}`,
        type: mimeType,
        title,
        attachmentSize: `${(fileSize / 1024).toFixed(2)}KB`,
      },
    });
  };

  handleFileUpload = async (
    file: Blob,
    mimeType: string,
    fileTitle: string,
    fileSize: number
  ): Promise<boolean> => {
    const { url, fileName } =
      await ApiManager.getAlbusApis().getDocPreSignedUrlForUpload(
        "DOCTOR",
        this.props.doctorProfile.id
      );
    return ApiUtils.apiFormDataRequest(url, file, mimeType)
      .then(() => {
        console.log("Uploaded");
        this.setAttachmentDetails(fileName, mimeType, fileTitle, fileSize);
        return true;
      })
      .catch(() => {
        console.log("error uploading");
        this.setState({
          attachmentDetails: null,
        });
        return false;
      });
  };

  render() {
    const loadingIconStatus: boolean =
      this.state.loadingMessageState !== LOADING_INITIAL_MESSAGES_STATE.LOADED;
    const isMobile = AppUtils.getIsMobile();
    const showUploadScreenClass = this.props.showFileUploadScreen
      ? "showIt"
      : "";
    const chatDisplay: string =
      this.state.loadingMessageState === LOADING_INITIAL_MESSAGES_STATE.LOADED
        ? "flex"
        : "none";
    return (
      <div className="chat-wrapper">
        <div className="chat-container">
          <div className="right">
            {(loadingIconStatus || this.props.clientsLoading) && (
              <div className={"chat-loader-cont"}>
                <AppLoader
                  text={AppMessages.CHAT_CONTAINER_FETHING_CHAT_DETAILS}
                />
              </div>
            )}
            <div
              style={{ display: chatDisplay }}
              className={"inner-chat-container"}
            >
              <div className="write">
                <textarea
                  id="messageInputTextBox"
                  className="minimal-scrollbar"
                  rows={1}
                  placeholder="Start Typing Here..."
                  autoComplete="off"
                  onKeyDown={this.onEnterPressedInMessageInput}
                />
                <div className="chat-send-button-wrapper">
                  <img
                    className={"attach-file-icon"}
                    onClick={this.props.toggleFileUploadScreen}
                    src={"/images/attach.svg"}
                  />
                  <img
                    className={"send-icon"}
                    onClick={this.onSendMessageButtonClicked}
                    src={
                      isMobile
                        ? "/images/send-msg.svg"
                        : ORION_IMG_URL + "icons/send-message-button.png"
                    }
                  />
                </div>
              </div>
              <div className={"active-chat-container"}>
                <div id="chatMessagesScrollContainer" className="chat">
                  {this.state.fetchingPrevMessages && (
                    <div className={"load-msg"}>
                      <img
                        src={ORION_IMG_URL + "loader/eclipse-loader-16.gif"}
                      />
                      <p>loading messages...</p>
                    </div>
                  )}
                  {this.generateChatMessages()}
                </div>
              </div>
            </div>
          </div>
          <div className={`upload-screen ${showUploadScreenClass}`}>
            <FileUploader
              accept={".jpg, .png, .jpeg, .pdf"}
              handleFileUpload={this.handleFileUpload}
              resetKey={this.props.showFileUploadScreen}
            />
            <Form>
              {(formProps: any) => {
                const { onUpdateField, formData, resetFormData } = formProps;
                return (
                  <div className={"upload-form"}>
                    <TextInput
                      placeholder={"Add Title"}
                      onChange={(e) => onUpdateField("title", e.target.value)}
                      value={formData.title || ""}
                    />
                    <CTA
                      innerText={"Done"}
                      disabled={_.isEmpty(this.state.attachmentDetails)}
                      theme={CTATheme.PRIMARY}
                      onClick={() =>
                        this.handleUploadDoneClick(formData, resetFormData)
                      }
                    />
                  </div>
                );
              }}
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IAppState, ownProps: any): any {
  return {
    twilioContext: state.twilioContext,
    doctorProfile: state.doctorProfile,
  };
}

function mapDispatchToProps(dispatch: any): any {
  return {
    updateCurrentChannel: (channelSid: string) => {
      return dispatch(TwilioActions.updateCurrentChannel(channelSid));
    },
    setCurrentChannel: (channelSid: string) => {
      return dispatch(TwilioActions.setCurrentChannel(channelSid));
    },
    updateChannelInfo: (channel: any[]) => {
      return dispatch(TwilioActions.updateChannelInfo(channel));
    },
    removeUnReadMessage: (channelSid : string ,unreadMessageInfo : any) => {
      return dispatch(TwilioActions.removeUnReadMessageInfo(dispatch, channelSid, unreadMessageInfo));
    },
    updateConsumptionHorizon: (channelSid: string, prevMessage: any) => {
        return TwilioActions.updateConsumptionHorizon(dispatch,channelSid, prevMessage);
    },
    getUnreadMessagesInfo: (doctorId: string) => {
      return TwilioActions.getUnreadMessageInfo(dispatch, doctorId);
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatContainer);
